import { Component, OnInit } from '@angular/core';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';

@Component({
  selector: 'app-withdrawal-base'
})

export class WithdrawalBaseComponent implements OnInit {

    constructor(){

    }

    ngOnInit(): void {}

    handleError(error: GlobalErrorHandlerService) {
        
        let message = '';
        switch (error.getErrorCode().toUpperCase()) {
            case 'PROCESSOR_ERROR':
                error.setErrorMessage('Sorry, an error occured processing your deposit. Please try again');
                break;
            case 'INVALID_AMOUNT_MAX':
                message = 'Deposit amount is more than the maximum amount allowed';
                if (error.getPayload()) {
                    message = error.getPayload();
                }
                error.setErrorMessage(message);
            case 'INVALID_AMOUNT_MIN':
                message = 'Deposit amount is less than the minimum amount required';
                if (error.getPayload()) {
                    message = error.getPayload();
                }
                error.setErrorMessage(message);
                break;
            case 'CUSTOMER_IS_A_TEST_ACCOUNT':
                error.setErrorMessage('Failed. Customer is a test account');
                break;
            case 'INVALID_PARAMETER':
                error.setErrorMessage(error.getErrorMessage());
                break;
            default:
                if (error.getPayload()) {
                    message = error.getPayload();
                }
                error.setErrorMessage(message);
                break;
                
        }
        return error;
    }

}
